export default __webpack_public_path__ + "static/media/elearningLogo.51560064.svg";